<template>
    <div id="vehiclemodel_list">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Asset Model List</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <router-link v-if="canAddMod" class="btn btn-primary pull-right" v-bind:to="{name: 'AssetModelCreate'}" > <i class="fp-add"> </i> Add</router-link>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content asset-model-list">
                        <data-table-filter-config :moduleName="'assetModList'" ref="filterModelList" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'assetModList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listVehicleModelTable"
                                    mode="remote"
                                    title="AssetModel"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-select-all="onSelectAll"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: asset_mode_value,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <router-link title="Edit Asset Model" v-if="canUpdateMod == true" class="fp-edit" v-bind:to="{name: 'AssetModelEdit',params:{id:props.row.id}}"></router-link>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <button v-if="asset_mode_value" id="deleteVehicleModelBtn" v-on:click.prevent="VehicleModelDelete" class="btn btn-primary">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";
import EventBus from "./event-bus";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "VehicleModelList",
        metaInfo() {
            return {title: "Asset Model List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            userColumns:[],
            cantAccessPage: "",
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: 'Asset Model Name',
                    field: 'name',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Asset Model Code',
                    field: 'code',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Asset Manufacturer',
                    field: 'vehicle_manufacturer_id',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Manufacturer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            asset_mode_value: false,
            loading:false,
            canAddMod:false,
            canUpdateMod:false,
            action:'list',
            pageKey:"_asset_model_list_",
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_asset_model') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_asset_model') {
                            self.asset_mode_value = true;
                        }
                        if (permissions[i].name == 'add_asset_model') {
                            self.canAddMod = true;
                            self.canUpdateMod = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            //self.loadList();
            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listVehicleModelTable.unselectAllInternal();
            },

            /*updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadList();
            },
            onPerPageChange(params) {
                this.serverParams.page=1;
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadList();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field:('name');
                    field:('code');
                };
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                if (this.firstLoad == 1 || filters.name || filters.code) {
                    this.loadList();
                }
            },*/
            selectionChanged(param) {
                var self = this;
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
            },
            /*onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadList();
            },*/
            loadList() {
                var data = this.$refs['listVehicleModelTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listVehicleModelTable'].selectedRows[i].id)
                }
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    // messageData: self.message,
                    sort: self.serverParams.sort,
                    // exportFiltered: self.exportFilteredFlag
                    action:self.action,
                    all:self.serverParams.selectedAll,
                    id:use
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/assetmodel/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            if (self.action == 'delete'){
                                self.action = 'list';
                                self.$refs.filterModelList.clearSelectAll();
                                EventBus.$emit('clear-all-flags', false);
                                self.loadList();
                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                            }
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'load-asset-model-list')
                    }
                });
            },
            VehicleModelDelete() {
                var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this Asset Model?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      self.action = 'delete';
                      self.loadList();
                      //console.log("list of IDS =", use);

                    } else {
                      console.log("no");
                    }
                });
                
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/AssetModelList.vue